module.exports = __webpack_public_path__ + "img/trentino.87f2f730.svg";